function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-321.172 -179.326)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M339.551,183.636h-.735q-4.373,0-8.747,0c-.72,0-1.2-.392-1.2-.969s.445-.965,1.192-.966q5.181-.006,10.364,0c1.111,0,1.565.619,1.253,1.672q-1.036,3.492-2.082,6.981a1.229,1.229,0,0,1-1.331.962q-5.063,0-10.125,0a1.426,1.426,0,0,1-1.562-1.383q-.669-4.1-1.35-8.2c-.025-.154-.079-.3-.13-.493-.947,0-1.884,0-2.82,0-.711,0-1.109-.359-1.1-.967s.408-.943,1.125-.947q1.707,0,3.415,0c.853,0,1.139.222,1.283,1.082.424,2.515.842,5.03,1.237,7.551.221,1.411.2,1.415,1.638,1.415,2.475,0,4.952-.01,7.428.008a.6.6,0,0,0,.7-.516c.453-1.589.952-3.165,1.431-4.746C339.473,183.991,339.5,183.856,339.551,183.636Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(326.768 192.49)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M328.984,196.808a2.546,2.546,0,1,1,2.544-2.546A2.548,2.548,0,0,1,328.984,196.808Zm0-3.52a.974.974,0,1,0,.973.974A.975.975,0,0,0,328.984,193.288Z",
  transform: "translate(-326.439 -191.717)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(334.2 192.49)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M335.981,196.808a2.546,2.546,0,1,1,2.544-2.546A2.549,2.549,0,0,1,335.981,196.808Zm0-3.52a.974.974,0,1,0,.973.974A.975.975,0,0,0,335.981,193.288Z",
  transform: "translate(-333.435 -191.717)"
})));

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1899ae",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.6,
    height: 18.255,
    viewBox: "0 0 20.6 18.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.122d57cf1e8e9beaea6876d90b9ad519.svg";
export { ForwardRef as ReactComponent };